import { render } from "./v-settings.vue?vue&type=template&id=e879e32e"
import script from "./v-settings.vue?vue&type=script&lang=js"
export * from "./v-settings.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__